// usersSlice.ts
import { createSlice } from "@reduxjs/toolkit";
import { fetchUsersListAsync, fetchSearchedUsersListAsync, fetchUserProfileAsync, resetPasswordAsync, updateUserProfileAsync, updateUserStatusAsync } from "../thunks/UsersThunk";
import { STATUS } from "./OrganizationSlice";

interface UsersState {
  users: any[];  // Replace with proper User type if needed
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
  statusCode: number | null;
  total_pages: number;
  total_items: number;
  filteredUsers: any[];
  userProfileData:any
  userProfileStatus:string
  resetPasswordStatus: string;
  updateProfileStatus: string;
  updateStatusStatus: string;
  inviteStatus:string;
}

const initialState: UsersState = {
  users: [],
  status: "idle",
  error: null,
  statusCode:null,
  total_pages: 0,
  total_items: 0,
  filteredUsers: [],
  userProfileData:null,
  userProfileStatus:STATUS.IDLE,
  resetPasswordStatus: STATUS.IDLE,
  updateProfileStatus: STATUS.IDLE,
  updateStatusStatus: STATUS.IDLE,
  inviteStatus: STATUS.IDLE
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsersListAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchUsersListAsync.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.users = action.payload.items; 
        state.total_pages = action.payload.total_pages;
        state.total_items = action.payload.total_items;
      })
      .addCase(fetchUsersListAsync.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      })
      .addCase(fetchSearchedUsersListAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchSearchedUsersListAsync.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.filteredUsers = action.payload.items; 
        state.total_pages = action.payload.total_pages;
        state.total_items = action.payload.total_items;
      })
      .addCase(fetchSearchedUsersListAsync.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      })


      .addCase(fetchUserProfileAsync.pending, (state) => {
        state.userProfileStatus = "loading";
      })
      .addCase(fetchUserProfileAsync.fulfilled, (state, action) => {
        state.userProfileStatus = "succeeded";
        state.userProfileData = action.payload; 
 
      })
      .addCase(fetchUserProfileAsync.rejected, (state, action) => {
        state.userProfileStatus = "failed";
        state.error = action.payload as string;
      })

      .addCase(resetPasswordAsync.pending, (state) => {
        state.resetPasswordStatus = "loading";
      })
      .addCase(resetPasswordAsync.fulfilled, (state, action) => {
        state.resetPasswordStatus = "succeeded";
      })
      .addCase(resetPasswordAsync.rejected, (state, action) => {
        state.resetPasswordStatus = "failed";
        state.error = action.payload as string;
      })

      .addCase(updateUserProfileAsync.pending, (state) => {
        state.updateProfileStatus = "loading";
      })
      .addCase(updateUserProfileAsync.fulfilled, (state, action) => {
        state.updateProfileStatus = "succeeded";
        // Update the userProfileData with the new data
       // state.userProfileData = { ...state.userProfileData, ...action.payload };
      })
      .addCase(updateUserProfileAsync.rejected, (state, action) => {
        state.updateProfileStatus = "failed";
        if (typeof action.payload === "object" && action.payload !== null && "data" in action.payload) {
          state.statusCode = (action.payload as { status?: number }).status || null;
          if (state.statusCode === 409) {
            state.error = (action.payload as { data?: { msg?: string } }).data?.msg ?? null;
          } else {
            state.error = "Profile updates could not be saved.";
          }
        } else {
          state.error = action.payload as string;
          state.statusCode = null;
        }
      })

      .addCase(updateUserStatusAsync.pending, (state) => {
        state.updateStatusStatus = "loading";
      })
      .addCase(updateUserStatusAsync.fulfilled, (state, action) => {
        state.updateStatusStatus = "succeeded";
        
      })
      .addCase(updateUserStatusAsync.rejected, (state, action) => {
        state.updateStatusStatus = "failed";
        state.error = action.payload as string;
      })
      ;
  },
});

export default usersSlice.reducer;
